class ReviewsTicker {
  constructor() {
    this.init();
  }

  init() {
    this.container = document.querySelector(".reviews-wrapper");

    if (!this.container) return;

    this.velocity = 2;
    this.numOriginals = 6;
    this.posX = 0;
  
    this.observerTarget = document.querySelector("#reviews");
    this.children = this.container.querySelectorAll(".review-item");

    this.refresh();

    this.start();
  }

  /* Needs to re-run calculation because of asset-loading and delayed resizing causing a glitch when looping */
  refresh() {
    const child0 = this.children[0].getBoundingClientRect();
    const child1 = this.children[1].getBoundingClientRect();
    const clone0 = this.children[this.numOriginals].getBoundingClientRect();
    this.loopX = - (Math.abs(child0.x) + Math.abs(clone0.x));
  }

  initObserver() {
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    };

    let observer = new IntersectionObserver(
      this.handleIntersect.bind(this),
      options
    );

    observer.observe(this.observerTarget);
  }

  handleIntersect(evt) {
    this.paused = !evt[0].isIntersecting;
  }

  start() {
    window.requestAnimationFrame(this.step.bind(this));
  }

  play() {
    this.paused = false;
  }

  pause() {
    this.paused = true;
  }

  step() {
    const restart = this.posX <= this.loopX;
    const doRefresh = this.posX < this.loopX * 0.5 && this.posX > this.loopX * 0.5 - this.velocity;

    if (!this.paused) {
      this.posX = restart ? 0 : this.posX - this.velocity;
      this.container.style.transform = `translateX(${this.posX}px)`;

      if(doRefresh) {
        this.refresh();
      }
    }

    this.start();
  }
}

(function ($) {
  window.reviewsTicker = new ReviewsTicker();

  // Play - Pause Animation
  let btn = document.querySelector(".play-pause-wrapper");
  if (!btn) return;
  else {
    let icon = btn.querySelector(".icon i");
    let text = btn.querySelector(".text");

    btn.addEventListener("click", function () {
      if (icon.classList.contains("fa-play")) {
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        text.innerHTML = "Pause";
        window.reviewsTicker.play();
        btn.setAttribute("aria-pressed", "false");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        text.innerHTML = "Play";
        window.reviewsTicker.pause();
        btn.setAttribute("aria-pressed", "true");
      }
    });
  }
})(jQuery);
